import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './TipCard.module.scss'
import { Text } from 'blaze-ui/Text/Text'

export const TipCard = ({ title, description, image }: { title: string; description: string; image: string }) => {
  return (
    <div className={Styles.tipCard}>
      <div className={Styles.tipTitle}>💡 Blaze Tip:</div>
      <img src={image} alt="Tip" />
      <Heading level={5}>{title}</Heading>
      <Text color="var(--dark-60)">{description}</Text>
    </div>
  )
}
